import '../css/main.css';
import './modules/carousel-background';
import './modules/categories-grid';
import { initAirplaneCursor } from './modules/cursor-airplane';


/* -------------------- MENU MOBILE -------------------- */
function initMobileMenu() {
    const mobileToggle = document.getElementById('mobile-menu-toggle');
    const mobileMenu = document.getElementById('mobile-menu');

    if (!mobileToggle || !mobileMenu) return;

    mobileToggle.addEventListener('click', e => {
        e.preventDefault();
        const isExpanded = mobileToggle.getAttribute('aria-expanded') === 'true';
        mobileToggle.setAttribute('aria-expanded', !isExpanded);
        mobileMenu.classList.toggle('hidden');

        const svg = mobileToggle.querySelector('svg');
        if (svg) svg.classList.toggle('rotate-90');
    });

    document.addEventListener('click', e => {
        if (!mobileToggle.contains(e.target) && !mobileMenu.contains(e.target)) {
            mobileMenu.classList.add('hidden');
            mobileToggle.setAttribute('aria-expanded', 'false');
            const svg = mobileToggle.querySelector('svg');
            if (svg) svg.classList.remove('rotate-90');
        }
    });

    window.addEventListener('resize', () => {
        if (window.innerWidth >= 768) {
            mobileMenu.classList.add('hidden');
            mobileToggle.setAttribute('aria-expanded', 'false');
            const svg = mobileToggle.querySelector('svg');
            if (svg) svg.classList.remove('rotate-90');
        }
    });
}

/* -------------------- SCROLL SUAVE -------------------- */
function initSmoothScroll() {
    document.querySelectorAll('a[href*="#"]:not([href="#"])').forEach(link => {
        link.addEventListener('click', e => {
            const target = document.querySelector(link.hash);
            if (target) {
                e.preventDefault();
                window.scrollTo({
                    top: target.offsetTop - 80,
                    behavior: 'smooth'
                });
            }
        });
    });
}

/* -------------------- LAZY LOADING -------------------- */
function initLazyLoading() {
    if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries, obs) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    const img = entry.target;
                    img.src = img.dataset.src;
                    img.classList.remove('lazy');
                    img.classList.add('fade-in');
                    obs.unobserve(img);
                }
            });
        });

        document.querySelectorAll('img[data-src]').forEach(img => observer.observe(img));
    }
}

/* -------------------- SEARCH TOGGLE -------------------- */
function initSearchToggle() {
    const searchToggle = document.querySelector('.search-toggle');
    const searchForm = document.querySelector('.search-form');

    if (!searchToggle || !searchForm) return;

    searchToggle.addEventListener('click', e => {
        e.preventDefault();
        searchForm.classList.toggle('active');
        const input = searchForm.querySelector('input[type="search"]');
        if (searchForm.classList.contains('active') && input) input.focus();
    });

    document.addEventListener('keydown', e => {
        if (e.key === 'Escape' && searchForm.classList.contains('active')) {
            searchForm.classList.remove('active');
        }
    });
}

/* -------------------- FORMULÁRIO DE COMENTÁRIOS -------------------- */
function initCommentForm() {
    const commentForm = document.getElementById('commentform');
    if (!commentForm) return;

    commentForm.addEventListener('submit', e => {
        const comment = document.getElementById('comment');
        const author = document.getElementById('author');
        const email = document.getElementById('email');

        let hasError = false;

        document.querySelectorAll('.form-error').forEach(el => el.classList.remove('form-error'));
        document.querySelectorAll('.error-message').forEach(el => el.remove());

        if (!comment.value.trim()) { showFieldError(comment, 'Por favor, escreva um comentário.'); hasError = true; }
        if (author && !author.value.trim()) { showFieldError(author, 'Por favor, informe seu nome.'); hasError = true; }
        if (email && (!email.value.trim() || !isValidEmail(email.value))) { showFieldError(email, 'Por favor, informe um email válido.'); hasError = true; }

        if (hasError) {
            e.preventDefault();
            const firstError = document.querySelector('.form-error');
            if (firstError) {
                window.scrollTo({
                    top: firstError.getBoundingClientRect().top + window.scrollY - 100,
                    behavior: 'smooth'
                });
            }
        }
    });
}

function showFieldError(field, message) {
    field.classList.add('form-error', 'border-gray-600');
    const errorMsg = document.createElement('div');
    errorMsg.className = 'error-message text-gray-600 text-sm mt-1';
    errorMsg.textContent = message;
    field.parentNode.appendChild(errorMsg);
}

function isValidEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
}

/* -------------------- BOTÃO VOLTAR AO TOPO -------------------- */
function initBackToTop() {
    const backToTop = document.createElement('button');
    backToTop.id = 'back-to-top';
    backToTop.setAttribute('aria-label', 'Voltar ao topo');
    backToTop.className = 'fixed bottom-6 right-6 bg-primary-600 text-white p-3 rounded-full shadow-lg hover:bg-primary-700 transition-all duration-300 z-50 opacity-0 invisible';
    backToTop.innerHTML = '<svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20"><path fill-rule="evenodd" d="M14.707 12.707a1 1 0 01-1.414 0L10 9.414l-3.293 3.293a1 1 0 01-1.414-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 010 1.414z" clip-rule="evenodd"></path></svg>';
    document.body.appendChild(backToTop);

    window.addEventListener('scroll', () => {
        if (window.scrollY > 300) {
            backToTop.classList.remove('opacity-0', 'invisible');
            backToTop.classList.add('opacity-100', 'visible');
        } else {
            backToTop.classList.remove('opacity-100', 'visible');
            backToTop.classList.add('opacity-0', 'invisible');
        }
    });

    backToTop.addEventListener('click', () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    });
}

/* -------------------- HERO OVERLAY GSAP -------------------- */
function initHeroOverlayScroll() {
    if (!window.gsap || !window.ScrollTrigger) return;

    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReducedMotion) return;

    const overlays = Array.from(document.querySelectorAll('[data-section-overlay]'));
    if (!overlays.length) return;

    window.gsap.registerPlugin(window.ScrollTrigger);

    const syncHeroOverlayState = () => {
        window.requestAnimationFrame(() => {
            window.ScrollTrigger.refresh();
            window.ScrollTrigger.update();
        });
    };

    overlays.forEach(overlay => {
        const targetSelector = overlay.dataset.overlayTarget;
        const overlayTarget = targetSelector ? document.querySelector(targetSelector) : overlay.nextElementSibling;
        if (!overlayTarget) return;

        const start = overlay.dataset.overlayStart || 'top top';
        const end = overlay.dataset.overlayEnd || '+=80%';
        const targetShift = Number.parseFloat(overlay.dataset.overlayTargetY || '-120');
        const textSelector = overlay.dataset.overlayTextSelector || '[data-section-content]';

        const tl = window.gsap.timeline({
            scrollTrigger: {
                trigger: overlay,
                start,
                end,
                scrub: true,
                pin: true,
                pinSpacing: false,
                anticipatePin: 1
            }
        });

        tl.fromTo(overlay, { opacity: 1, scale: 1, filter: 'blur(0px)' }, {
            opacity: 0.6,
            filter: 'blur(6px)',
            ease: 'none'
        }, 0);

        const heroText = overlay.querySelectorAll(textSelector);
        if (heroText.length) {
            tl.fromTo(heroText, { opacity: 1, y: 0, filter: 'blur(0px)' }, {
                opacity: 0.2,
                y: 20,
                scale: 0.92,
                filter: 'blur(8px)',
                ease: 'none'
            }, 0);
        }

        tl.fromTo(overlayTarget, { y: targetShift }, { y: 0, ease: 'none' }, 0);
    });

    syncHeroOverlayState();
    window.addEventListener('load', syncHeroOverlayState, { once: true });
    window.addEventListener('pageshow', syncHeroOverlayState);
    window.addEventListener('resize', syncHeroOverlayState);
}

/* -------------------- SECTION OVERLAY GSAP -------------------- */
function initSectionOverlayScroll() {
    if (!window.gsap || !window.ScrollTrigger) return;

    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReducedMotion) return;

    const section = document.querySelector('.section-overlay');
    const overlayTarget = document.querySelector('.section-overlay-target') || section?.nextElementSibling;
    if (!section || !overlayTarget) return;

    window.gsap.registerPlugin(window.ScrollTrigger);

    const tl = window.gsap.timeline({
        scrollTrigger: {
            trigger: section,
            start: 'top top',
            end: '+=70%',
            scrub: true,
            pin: true,
            pinSpacing: false,
            anticipatePin: 1
        }
    });

    tl.fromTo(section, { opacity: 1, scale: 1, filter: 'blur(0px)' }, {
        // opacity: 0.7,
        scale: 0.96,
        filter: 'blur(4px)',
        ease: 'none'
    }, 0);

    tl.fromTo(overlayTarget, { y: 120, opacity: 1 }, { y: 0, opacity: 1, ease: 'none' }, 0);
}

/* -------------------- DICAS GSAP -------------------- */
function initTipsGsap() {
    if (!window.gsap || !window.ScrollTrigger) return;

    const section = document.querySelector('[data-tips-section]');
    if (!section || section.dataset.tipsGsapReady === 'true') return;

    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReducedMotion) return;

    section.dataset.tipsGsapReady = 'true';
    window.gsap.registerPlugin(window.ScrollTrigger);

    const cards = Array.from(section.querySelectorAll('[data-tips-card]'));
    if (!cards.length) return;

    window.gsap.fromTo(cards, {
        autoAlpha: 0,
        y: 36,
        scale: 0.98
    }, {
        autoAlpha: 1,
        y: 0,
        scale: 1,
        duration: 0.9,
        ease: 'power2.out',
        stagger: 0.12,
        scrollTrigger: {
            trigger: section,
            start: 'top 75%'
        }
    });
}


/* -------------------- NOSSAS VIAGENS SWIPER -------------------- */
function initFeaturedSwiper() {
    if (!window.Swiper) {
        console.log('[initFeaturedSwiper] Swiper library not loaded');
        return;
    }

    const slider = document.querySelector('.featured-swiper');
    console.log('[initFeaturedSwiper] Slider element found:', slider);
    console.log('[initFeaturedSwiper] Slides count:', slider ? slider.querySelectorAll('.swiper-slide').length : 0);
    
    if (!slider) {
        console.warn('[initFeaturedSwiper] featured-swiper element not found in DOM');
        return;
    }
    if (slider.dataset.swiperReady === 'true') {
        console.log('[initFeaturedSwiper] Swiper already initialized');
        return;
    }
    slider.dataset.swiperReady = 'true';

    console.log('[initFeaturedSwiper] Initializing Swiper...');
    new window.Swiper(slider, {
        slidesPerView: 2.5,
        spaceBetween: 24,
        speed: 700,
        grabCursor: true,   
        slidesOffsetBefore: 170,
        navigation: {
            nextEl: slider.querySelector('.swiper-button-next'),
            prevEl: slider.querySelector('.swiper-button-prev')
        },
        // pagination: {
        //     el: slider.querySelector('.swiper-pagination'),
        //     clickable: true
        // },
        breakpoints: {
            0: {
                slidesPerView: 1.1,
                spaceBetween: 16,
                slidesOffsetBefore: 0
            },
            640: {
                slidesPerView: 1.6,
                spaceBetween: 18,
                slidesOffsetBefore: 0
            },
            1024: {
                slidesPerView: 2.5,
                spaceBetween: 24
            }
        }
    });
}

/* -------------------- CONTAGEM DE ESTATISTICAS -------------------- */
function initStatsCountUp() {
    const statNumbers = document.querySelectorAll('[data-countup]');
    if (!statNumbers.length) return;

    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const parseTarget = raw => {
        const cleaned = String(raw || '0').trim();
        const normalized = cleaned.replace(/\./g, '').replace(',', '.');
        const value = Number.parseFloat(normalized);
        return Number.isFinite(value) ? value : 0;
    };

    const getFractionDigits = raw => {
        const cleaned = String(raw || '').trim();
        const match = cleaned.match(/[.,](\d+)/);
        return match ? match[1].length : 0;
    };

    const formatNumber = (value, raw) => {
        const digits = getFractionDigits(raw);
        return new Intl.NumberFormat('pt-BR', {
            minimumFractionDigits: digits,
            maximumFractionDigits: digits
        }).format(value);
    };

    const setFinalValue = el => {
        const targetRaw = el.dataset.target;
        const prefix = el.dataset.prefix || '';
        const suffix = el.dataset.suffix || '';
        const targetValue = parseTarget(targetRaw);
        el.textContent = `${prefix}${formatNumber(targetValue, targetRaw)}${suffix}`;
    };

    statNumbers.forEach(setFinalValue);
    if (prefersReducedMotion) return;
}

/* -------------------- BOLHAS COM GSAP -------------------- */
function initStatsBubbles() {
    const container = document.querySelector('[data-stats-bubbles]');
    if (!container || !window.gsap) return;

    const bubbles = Array.from(container.querySelectorAll('[data-stat-orb]'));
    if (!bubbles.length) return;

    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const isMobile = window.innerWidth < 768;

    if (prefersReducedMotion || isMobile) {
        container.style.display = 'flex';
        container.style.flexWrap = 'wrap';
        container.style.gap = isMobile ? '12px' : '20px';
        container.style.justifyContent = 'center';
        container.style.alignItems = 'center';
        container.style.minHeight = 'auto';
        container.style.padding = isMobile ? '1rem 0' : '';
        bubbles.forEach(el => {
            el.style.position = 'relative';
            el.style.left = 'auto';
            el.style.top = 'auto';
            el.style.transform = 'none';
            el.style.animation = 'none';
            if (isMobile) {
                const sizeMap = {
                    'stat-orb--xl':  '5.5rem',
                    'stat-orb--lg':  '4.75rem',
                    'stat-orb--md':  '4rem',
                    'stat-orb--sm':  '3.25rem',
                    'stat-orb--xs':  '2.75rem',
                    'stat-orb--xxs': '2.25rem',
                };
                for (const [cls, size] of Object.entries(sizeMap)) {
                    if (el.classList.contains(cls)) {
                        el.style.width = size;
                        el.style.height = size;
                        break;
                    }
                }
            }
        });
        return;
    }

    if (container.dataset.bubblesReady === 'true') return;
    container.dataset.bubblesReady = 'true';

    let started = false;
    let resizeTimer = null;
    let width = 0;
    let height = 0;
    let ticker = null;
    let lastTickTime = 0;
    let lastCollisionTime = 0;
    const targetFrameMs = 33;
    const collisionFrameMs = 66;
    const bubbleData = [];

    const setBounds = () => {
        const rect = container.getBoundingClientRect();
        width = rect.width;
        height = Math.max(rect.height, 520);
        container.style.minHeight = `${height}px`;
    };

    const layoutBubbles = () => {
        setBounds();
        bubbleData.length = 0;

        const padding = 20;
        const columns = Math.min(4, Math.max(2, Math.round(width / 200)));
        const maxRadius = Math.max(...bubbles.map(el => Math.max(el.offsetWidth, el.offsetHeight) / 2));
        const stepX = Math.max((width - padding * 2 - maxRadius * 2) / Math.max(columns - 1, 1), 90);
        const stepY = 38;

        bubbles.forEach((el, index) => {
            const size = Math.max(el.offsetWidth, el.offsetHeight);
            const radius = size / 2;
            const col = index % columns;
            const row = Math.floor(index / columns);
            const stairOffset = index * 14;
            const baseX = padding + radius + col * stepX + stairOffset * 0.12;
            const baseY = padding + radius + row * stepY + stairOffset * 0.38;
            const jitterX = (Math.random() - 0.5) * 40;
            const jitterY = (Math.random() - 0.5) * 30;

            const x = Math.min(width - radius - padding, Math.max(radius + padding, baseX + jitterX));
            const y = Math.min(height - radius - padding, Math.max(radius + padding, baseY + jitterY));

            const baseRotation = (Math.random() - 0.5) * 10;
            const baseScale = 0.96 + Math.random() * 0.08;

            const setX = window.gsap.quickSetter(el, 'x', 'px');
            const setY = window.gsap.quickSetter(el, 'y', 'px');
            const setRotation = window.gsap.quickSetter(el, 'rotation', 'deg');

            bubbleData.push({
                el,
                radius,
                x,
                y,
                vx: (Math.random() - 0.5) * 0.6,
                vy: (Math.random() - 0.5) * 0.6,
                rotation: baseRotation,
                scale: baseScale,
                setX,
                setY,
                setRotation
            });

            window.gsap.set(el, {
                x: x - radius,
                y: y - radius,
                rotation: baseRotation,
                scale: baseScale
            });
        });
    };

    const simulateBubbles = () => {
        if (ticker) return;

        ticker = () => {
            if (!bubbleData.length) return;
            const now = window.performance.now();
            if (now - lastTickTime < targetFrameMs) return;
            lastTickTime = now;

            const time = now * 0.001;
            const runCollisions = now - lastCollisionTime >= collisionFrameMs;
            if (runCollisions) lastCollisionTime = now;

            if (runCollisions) {
                for (let i = 0; i < bubbleData.length; i += 1) {
                    const a = bubbleData[i];
                    for (let j = i + 1; j < bubbleData.length; j += 1) {
                        const b = bubbleData[j];
                        const dx = b.x - a.x;
                        const dy = b.y - a.y;
                        const minDist = a.radius + b.radius + 8;

                        if (Math.abs(dx) > minDist || Math.abs(dy) > minDist) continue;

                        const dist2 = dx * dx + dy * dy;
                        if (dist2 < minDist * minDist) {
                            const dist = Math.max(Math.sqrt(dist2), 0.001);
                            const force = (minDist - dist) * 0.015;
                            const nx = dx / dist;
                            const ny = dy / dist;
                            a.vx -= nx * force;
                            a.vy -= ny * force;
                            b.vx += nx * force;
                            b.vy += ny * force;
                        }
                    }
                }
            }

            bubbleData.forEach((bubble, index) => {
                bubble.vx += Math.sin(time * 1.2 + index) * 0.06;
                bubble.vy += Math.cos(time * 1.05 + index) * 0.06;

                bubble.vx *= 0.97;
                bubble.vy *= 0.97;

                bubble.x += bubble.vx;
                bubble.y += bubble.vy;

                if (bubble.x - bubble.radius < 0) {
                    bubble.x = bubble.radius;
                    bubble.vx *= -0.9;
                }
                if (bubble.x + bubble.radius > width) {
                    bubble.x = width - bubble.radius;
                    bubble.vx *= -0.9;
                }
                if (bubble.y - bubble.radius < 0) {
                    bubble.y = bubble.radius;
                    bubble.vy *= -0.9;
                }
                if (bubble.y + bubble.radius > height) {
                    bubble.y = height - bubble.radius;
                    bubble.vy *= -0.9;
                }

                bubble.rotation += bubble.vx * 0.15;

                bubble.setX(bubble.x - bubble.radius);
                bubble.setY(bubble.y - bubble.radius);
                bubble.setRotation(bubble.rotation);
            });
        };

        window.gsap.ticker.add(ticker);
    };

    const start = () => {
        if (started) return;
        started = true;
        layoutBubbles();
        simulateBubbles();
    };

    const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            if (!entry.isIntersecting) return;
            start();
            observer.disconnect();
        });
    }, { threshold: 0.2 });

    observer.observe(container);

    window.addEventListener('resize', () => {
        if (!started) return;
        window.clearTimeout(resizeTimer);
        resizeTimer = window.setTimeout(() => {
            layoutBubbles();
        }, 120);
    });
}



/* -------------------- AJAX UTIL -------------------- */
window.themeAjax = {
    request: function(action, data = {}, callback) {
        const formData = new FormData();
        formData.append('action', action);
        formData.append('nonce', themeAjax.nonce);
        Object.keys(data).forEach(key => formData.append(key, data[key]));

        fetch(themeAjax.ajaxurl, {
            method: 'POST',
            body: formData
        })
        .then(res => res.json())
        .then(res => {
            if (res.success) callback?.(res.data);
            else console.error('Erro AJAX:', res.data);
        })
        .catch(err => console.error('Erro na requisição AJAX:', err));
    },
    loadMorePosts: function(page, callback) {
        this.request('load_more_posts', { page }, callback);
    },
    likePost: function(postId, callback) {
        this.request('like_post', { post_id: postId }, callback);
    }
};

/* -------------------- INTERSECTION OBSERVER PARA ANIMAÇÕES -------------------- */
if ('IntersectionObserver' in window) {
    const animationObserver = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                if (entry.target.classList.contains('animate-on-scroll')) {
                    entry.target.classList.add('animate-fade-in');
                }
                if (entry.target.classList.contains('scroll-reveal')) {
                    entry.target.classList.add('is-visible');
                }
                animationObserver.unobserve(entry.target);
            }
        });
    }, { threshold: 0.1, rootMargin: '50px' });

    document.querySelectorAll('.animate-on-scroll, .scroll-reveal').forEach(el => animationObserver.observe(el));
}

document.addEventListener('DOMContentLoaded', () => {
    initTheme();
});

function initTheme() {
    initMobileMenu();
    initSmoothScroll();
    initLazyLoading();
    initAos();
    initHeroOverlayScroll();
    // initAboutGsap();
    initTipsGsap();
    // initSectionOverlayScroll();
    initFeaturedSwiper();
    initStatsCountUp();
    initAirplaneCursor();
    initCommentForm();
    initBackToTop();
    initDicasSwiper();
    initCategoriesSlider();
    initSingleHeroParallax();
    console.log('Custom Blocks Theme iniciado com sucesso!');
}

/* -------------------- DICAS SWIPER -------------------- */
function initDicasSwiper() {
    if (!window.Swiper) return;
    
    // Inicializa todos os swipers da página Dicas
    const dicasSwipers = document.querySelectorAll('.dicas-sections [class^="dicas-swiper-"]');
    
    dicasSwipers.forEach((swiperEl) => {
        new Swiper(swiperEl, {
            loop: true,
            pagination: {
                el: swiperEl.querySelector('.swiper-pagination'),
                clickable: true,
            },
            navigation: {
                nextEl: swiperEl.querySelector('.swiper-button-next'),
                prevEl: swiperEl.querySelector('.swiper-button-prev'),
            },
            autoplay: {
                delay: 5000,
                disableOnInteraction: false,
            },
        });
    });
}

/* -------------------- CATEGORIAS SLIDER -------------------- */
function initCategoriesSlider() {
    if (!window.location.pathname.includes('/categorias/')) return;
    if (!window.gsap) return;

    const dataEl = document.getElementById('categories-slider-data');
    if (!dataEl) return;

    let data = [];
    try {
        data = JSON.parse(dataEl.textContent || '[]');
    } catch (error) {
        console.error('Erro ao ler dados das categorias', error);
        return;
    }

    if (!data.length) return;

    const demo = document.getElementById('demo');
    const indicator = document.querySelector('[data-indicator]');
    const hasMultiple = data.length > 1;

    if (!demo) return;

    const cards = data.map((item, index) => (
        `<div data-card role="button" tabindex="0" class="absolute left-0 top-0 block bg-cover bg-center shadow-[6px_6px_10px_2px_rgba(0,0,0,0.6)] cursor-pointer" id="card${index}" style="background-image:url('${item.image}')" aria-label="${item.place}"></div>`
    )).join('');

    const cardContents = data.map((item, index) => (
        `<div data-card-content class="absolute left-0 top-0 pl-4 pr-2 text-white/90" style="max-width:200px" id="card-content-${index}">` +
        `<div data-content-start class="h-[5px] w-[30px] rounded-full bg-white/85"></div>` +
        `<div data-content-place class="mt-1 text-[11px] font-medium overflow-hidden text-ellipsis whitespace-nowrap">${item.place}</div>` +
        `<div data-content-title-1 class="font-oswald text-[clamp(13px,1.5vw,20px)] font-semibold overflow-hidden text-ellipsis whitespace-nowrap leading-tight">${item.title}</div>` +
        `<div data-content-title-2 class="font-oswald text-[clamp(13px,1.5vw,20px)] font-semibold overflow-hidden text-ellipsis whitespace-nowrap leading-tight">${item.title2}</div>` +
        `</div>`
    )).join('');

    demo.innerHTML = cards + cardContents;

    const range = (n) => Array(n).fill(0).map((i, j) => i + j);
    const set = window.gsap.set;
    const gsap = window.gsap;

    const getCard = (index) => `#card${index}`;
    const getCardContent = (index) => `#card-content-${index}`;
    const getSliderItem = (index) => `#slide-item-${index}`;

    function animate(target, duration, properties) {
        return new Promise((resolve) => {
            gsap.to(target, {
                ...properties,
                duration: duration,
                onComplete: resolve,
            });
        });
    }

    let order = range(data.length);
    let detailsEven = true;

    let offsetTop = 200;
    let offsetLeft = 700;
    let cardWidth = 200;
    let cardHeight = 300;
    let gap = 40;
    const visibleCards = 3.5;
    const ease = 'sine.inOut';

    function setDetailsContent(selector, item) {
        const root = document.querySelector(selector);
        if (!root || !item) return;
        const placeText = root.querySelector('[data-place-text]');
        const title1 = root.querySelector('[data-title-1]');
        const title2 = root.querySelector('[data-title-2]');
        const desc = root.querySelector('[data-desc]');
        const ctaWrap = root.querySelector('[data-cta]');
        const discover = root.querySelector('[data-cta] a');

        if (placeText) placeText.textContent = item.place;
        if (title1) title1.textContent = item.title;
        if (title2) title2.textContent = item.title2;
        if (desc) desc.textContent = item.description;
        if (discover) {
            discover.setAttribute('href', item.link || '#');
            discover.textContent = item.cta_label || 'Ver categoria';
        }
        if (ctaWrap) {
            ctaWrap.style.display = item.show_cta === false ? 'none' : 'flex';
        }
    }

    function init() {
        const [active, ...rest] = order;
        const detailsActive = detailsEven ? '#details-even' : '#details-odd';
        const detailsInactive = detailsEven ? '#details-odd' : '#details-even';
        const { innerHeight: height, innerWidth: width } = window;

        offsetTop = height - 430;
        const visibleGaps = Math.max(0, Math.ceil(visibleCards) - 1);
        const visibleWidth = (cardWidth * visibleCards) + (gap * visibleGaps);
        offsetLeft = Math.max(0, width - visibleWidth);

        setDetailsContent(detailsActive, data[active]);

        gsap.set(getCard(active), {
            x: 0,
            y: 0,
            width: window.innerWidth,
            height: window.innerHeight,
        });
        gsap.set(getCardContent(active), { x: 0, y: 0, opacity: 0 });
        gsap.set(detailsActive, { opacity: 0, zIndex: 22, x: -200 });
        gsap.set(detailsInactive, { opacity: 0, zIndex: 12 });
        gsap.set(`${detailsInactive} [data-place]`, { y: 100 });
        gsap.set(`${detailsInactive} [data-title-1]`, { y: 100 });
        gsap.set(`${detailsInactive} [data-title-2]`, { y: 100 });
        gsap.set(`${detailsInactive} [data-desc]`, { y: 50 });
        gsap.set(`${detailsInactive} [data-cta]`, { y: 60 });

        rest.forEach((i, index) => {
            gsap.set(getCard(i), {
                x: offsetLeft + 400 + index * (cardWidth + gap),
                y: offsetTop,
                width: cardWidth,
                height: cardHeight,
                zIndex: 30,
                borderRadius: 10,
            });
            gsap.set(getCardContent(i), {
                x: offsetLeft + 400 + index * (cardWidth + gap),
                zIndex: 40,
                y: offsetTop + cardHeight - 100,
            });
        });

        if (indicator) gsap.set(indicator, { x: -window.innerWidth });

        const startDelay = 0.6;

        gsap.to('[data-cover]', {
            x: width + 400,
            delay: 0.5,
            ease,
        });

        rest.forEach((i, index) => {
            gsap.to(getCard(i), {
                x: offsetLeft + index * (cardWidth + gap),
                zIndex: 30,
                ease,
                delay: startDelay,
            });
            gsap.to(getCardContent(i), {
                x: offsetLeft + index * (cardWidth + gap),
                zIndex: 40,
                ease,
                delay: startDelay,
            });
        });

        gsap.set(`${detailsActive} [data-place]`, { y: 40, opacity: 0 });
        gsap.set(`${detailsActive} [data-title-1]`, { y: 60, opacity: 0 });
        gsap.set(`${detailsActive} [data-title-2]`, { y: 60, opacity: 0 });
        gsap.set(`${detailsActive} [data-desc]`, { y: 30, opacity: 0 });
        gsap.set(`${detailsActive} [data-cta]`, { y: 30, opacity: 0 });

        gsap.to(detailsActive, { opacity: 1, x: 0, ease, delay: startDelay });
        gsap.to(`${detailsActive} [data-place]`,   { y: 0, opacity: 1, delay: startDelay + 0.1, duration: 0.6, ease });
        gsap.to(`${detailsActive} [data-title-1]`, { y: 0, opacity: 1, delay: startDelay + 0.18, duration: 0.7, ease });
        gsap.to(`${detailsActive} [data-title-2]`, { y: 0, opacity: 1, delay: startDelay + 0.24, duration: 0.7, ease });
        gsap.to(`${detailsActive} [data-desc]`,    { y: 0, opacity: 1, delay: startDelay + 0.35, duration: 0.5, ease });
        gsap.to(`${detailsActive} [data-cta]`,     { y: 0, opacity: 1, delay: startDelay + 0.42, duration: 0.5, ease });
    }

    let clicks = 0;

    function step() {
        return new Promise((resolve) => {
            order.push(order.shift());
            detailsEven = !detailsEven;

            const detailsActive = detailsEven ? '#details-even' : '#details-odd';
            const detailsInactive = detailsEven ? '#details-odd' : '#details-even';

            setDetailsContent(detailsActive, data[order[0]]);

            gsap.set(detailsActive, { zIndex: 22, opacity: 0 });
            gsap.set(`${detailsActive} [data-place]`,   { y: 40, opacity: 0 });
            gsap.set(`${detailsActive} [data-title-1]`, { y: 60, opacity: 0 });
            gsap.set(`${detailsActive} [data-title-2]`, { y: 60, opacity: 0 });
            gsap.set(`${detailsActive} [data-desc]`,    { y: 30, opacity: 0 });
            gsap.set(`${detailsActive} [data-cta]`,     { y: 30, opacity: 0 });

            gsap.to(detailsActive, { opacity: 1, delay: 0.3, ease });
            gsap.to(`${detailsActive} [data-place]`,   { y: 0, opacity: 1, delay: 0.35, duration: 0.6, ease });
            gsap.to(`${detailsActive} [data-title-1]`, { y: 0, opacity: 1, delay: 0.42, duration: 0.7, ease });
            gsap.to(`${detailsActive} [data-title-2]`, { y: 0, opacity: 1, delay: 0.48, duration: 0.7, ease });
            gsap.to(`${detailsActive} [data-desc]`,    { y: 0, opacity: 1, delay: 0.55, duration: 0.5, ease });
            gsap.to(`${detailsActive} [data-cta]`,     { y: 0, opacity: 1, delay: 0.6,  duration: 0.5, onComplete: resolve, ease });
            gsap.set(detailsInactive, { zIndex: 12 });

            const [active, ...rest] = order;
            const prv = rest[rest.length - 1];

            gsap.set(getCard(prv), { zIndex: 10 });
            gsap.set(getCard(active), { zIndex: 20 });
            gsap.to(getCard(prv), { scale: 1.5, ease });

            gsap.to(getCardContent(active), {
                y: offsetTop + cardHeight - 10,
                opacity: 0,
                duration: 0.3,
                ease,
            });
            gsap.to(getCard(active), {
                x: 0,
                y: 0,
                ease,
                width: window.innerWidth,
                height: window.innerHeight,
                borderRadius: 0,
                onComplete: () => {
                    const xNew = offsetLeft + (rest.length - 1) * (cardWidth + gap);
                    gsap.set(getCard(prv), {
                        x: xNew,
                        y: offsetTop,
                        width: cardWidth,
                        height: cardHeight,
                        zIndex: 30,
                        borderRadius: 10,
                        scale: 1,
                    });

                    gsap.set(getCardContent(prv), {
                        x: xNew,
                        y: offsetTop + cardHeight - 100,
                        opacity: 1,
                        zIndex: 40,
                    });

                    gsap.set(detailsInactive, { opacity: 0 });
                    gsap.set(`${detailsInactive} [data-place]`, { y: 100 });
                    gsap.set(`${detailsInactive} [data-title-1]`, { y: 100 });
                    gsap.set(`${detailsInactive} [data-title-2]`, { y: 100 });
                    gsap.set(`${detailsInactive} [data-desc]`, { y: 50 });
                    gsap.set(`${detailsInactive} [data-cta]`, { y: 60 });
                    clicks -= 1;
                    if (clicks > 0) {
                        step();
                    }
                },
            });

            rest.forEach((i, index) => {
                if (i !== prv) {
                    const xNew = offsetLeft + index * (cardWidth + gap);
                    gsap.set(getCard(i), { zIndex: 30 });
                    gsap.to(getCard(i), {
                        x: xNew,
                        y: offsetTop,
                        width: cardWidth,
                        height: cardHeight,
                        ease,
                        delay: 0.1 * (index + 1),
                    });

                    gsap.to(getCardContent(i), {
                        x: xNew,
                        y: offsetTop + cardHeight - 100,
                        opacity: 1,
                        zIndex: 40,
                        ease,
                        delay: 0.1 * (index + 1),
                    });
                }
            });
        });
    }

    async function start() {
        try {
            init();
        } catch (error) {
            console.error('Slider init failed', error);
        }
    }

    demo.addEventListener('click', (event) => {
        if (!hasMultiple) return;
        const card = event.target.closest('[data-card]');
        if (!card) return;
        event.preventDefault();

        const match = card.id && card.id.match(/card(\d+)/);
        if (!match) return;
        const targetIndex = Number.parseInt(match[1], 10);
        const position = order.indexOf(targetIndex);
        if (position <= 0) return;

        clicks += position;
        step();
    });

    const prevButton = document.querySelector('[data-slider-prev]');
    const nextButton = document.querySelector('[data-slider-next]');

    if (prevButton) {
        prevButton.addEventListener('click', () => {
            if (!hasMultiple) return;
            clicks += 1;
            step();
        });
    }

    if (nextButton) {
        nextButton.addEventListener('click', () => {
            if (!hasMultiple) return;
            clicks += 1;
            step();
        });
    }

    start();
}

/* -------------------- AOS -------------------- */
function initAos() {
    if (!window.AOS) return;
    window.AOS.init({
        duration: 900,
        easing: 'ease-out-cubic',
        once: false,
        mirror: true,
        offset: 120
    });
}
/* -------------------- SINGLE HERO PARALLAX -------------------- */
function initSingleHeroParallax() {
    const heroSection = document.querySelector('.single-post section.relative.overflow-hidden');
    const heroImage = heroSection?.querySelector('img');
    
    if (!heroSection || !heroImage || !window.gsap) return;

    heroSection.addEventListener('mousemove', (e)=> {
        const rect = heroSection.getBoundingClientRect();
        const x = (e.clientX - rect.left) / rect.width;
        const y = (e.clientY - rect.top) / rect.height;
        
        const moveX = (x - 0.5) * 30;
        const moveY = (y - 0.5) * 30;
        
        gsap.to(heroImage, {
            x: moveX,
            y: moveY,
            duration: 1.2,
            ease: 'power2.out'
        });
    });

    heroSection.addEventListener('mouseleave', ()  => {
        gsap.to(heroImage, {
            x: 0,
            y: 0,
            duration: 1,
            ease: 'power2.out'
        });
    });
}
